jQuery(function () {
    var plot = $('.garden-planning__plot');
    if (plot.length < 1) {
        return;
    }
    var plotArea = $('.js-plot-area');
    var toolItems = $('.js-tool-item');
    var textPopup = $('#garden-planning-text-popup');
    var mapInfoItems = $('.garden-plan__map-info-items');
    var mapInfoWrapper = $('.garden-plan__map-info');
    var toolEmpty = 'area-type-ground';
    var textItems = [];
    var coloringStart = false;
    var toolType = 'area-type-grass';
    var plotChanges = false;
    $(document).ready(function () {
        calculatePlotHeight();
        initTextItems();
    });
    toolItems.on('click', function () {
        toolItems.removeClass('selected');
        $(this).addClass('selected');
        toolType = $(this).data('tool-type');
        if (toolType === 'text') {
            plotArea.addClass('text-hover');
            plotArea.find('.hover-helper').css('border-color', '');
        }
        else {
            plotArea.removeClass('text-hover');
            plotArea.find('.hover-helper').css('border-color', $("." + toolType).css('background-color'));
        }
    });
    plotArea.on('click', function () {
        var area = $(this);
        if (toolType === 'text') {
            var row = area.data('row');
            var column = area.data('column');
            var infoItem = $('.garden-plan__map-info-item').filter("[data-row=\"" + row + "\"]")
                .filter("[data-column=\"" + column + "\"]");
            if (infoItem.length > 0) {
                textPopup.find('[name=TextInput]').val(infoItem.find('.info-item-text').text());
            }
            setTimeout(function () { textPopup.find('[name=TextInput]').focus(); }, 500);
            textPopup.find('[name=TextRow]').val(row);
            textPopup.find('[name=TextColumn]').val(column);
            textPopup.closest('.popup-overlay').addClass('visible');
        }
        else {
            changeAreaColor(area, toolType);
        }
    });
    plotArea.mousedown(function () {
        coloringStart = true;
    }).mousemove(function () {
        if (toolType === 'text' || !coloringStart) {
            return;
        }
        else {
            changeAreaColor($(this), toolType);
        }
    });
    $(window).mouseup(function () {
        coloringStart = false;
    });
    function changeAreaColor(area, selectedToolType) {
        area.attr('class', function (i, c) {
            return c.replace(/(^|\s)area-type-\S+/g, '');
        });
        var areaType = toolItems.filter("[data-tool-type=\"" + selectedToolType + "\"]").data('area-type');
        area.addClass(selectedToolType).attr('data-area-type', areaType);
        plotChanges = true;
    }
    $(window).on('resize', function () {
        calculatePlotHeight();
    });
    function calculatePlotHeight() {
        plot.height(plot.width());
    }
    function initTextItems() {
        var infoItems = $('.garden-plan__map-info-item');
        if (infoItems.length > 0) {
            mapInfoWrapper.removeClass('hidden');
            addTextHoverFunction();
            infoItems.each(function () {
                var textId = { row: $(this).data('row').toString(), column: $(this).data('column').toString() };
                textItems.push(textId);
            });
            var removeBtn = mapInfoItems.find('.js-info-item-remove-btn');
            if (removeBtn.length > 0) {
                removeBtn.delegate(this, 'click', function () {
                    removeTextOnClick($(this));
                });
            }
        }
    }
    $('.js-plot-area-add-text-btn').on('click', function (e) {
        e.preventDefault();
        var row = textPopup.find('[name=TextRow]').val();
        var column = textPopup.find('[name=TextColumn]').val();
        var text = textPopup.find('[name=TextInput]');
        var area = plotArea.filter("[data-row=\"" + row + "\"]").filter("[data-column=\"" + column + "\"]");
        var textId = { row: row, column: column };
        if (area.find('.info-item-identifier').length > 0) {
            var infoItem = $('.garden-plan__map-info-item').filter("[data-row=\"" + row + "\"]")
                .filter("[data-column=\"" + column + "\"]");
            infoItem.find('.info-item-text').text(text.val().toString());
        }
        else {
            textItems.push(textId);
            addListItem(text.val(), textId);
            var $blob = $('<div>', { 'class': 'info-item-identifier' });
            var $span = $('<span>').text($.inArray(textId, textItems) + 1);
            area.append($blob.append($span));
        }
        area.attr('data-text', text.val().toString());
        text.val('');
        addTextHoverFunction();
        mapInfoWrapper.removeClass('hidden');
        $(this).closest('.popup-overlay').removeClass('visible');
        plotChanges = true;
    });
    function addListItem(text, textId) {
        var $li = $('<li>', { 'class': 'garden-plan__map-info-item', 'data-row': textId.row, 'data-column': textId.column });
        var $number = $('<span>', { 'class': 'info-item-identifier' }).text(($.inArray(textId, textItems) + 1) + '.');
        var $text = $('<span>', { 'class': 'info-item-text' }).text(text);
        var $btn = $('<a>', { 'class': 'info-item-remove js-info-item-remove-btn', 'href': 'javascript:void(0)' });
        mapInfoItems.append($li.append($number).append($text).append($btn));
        var item = mapInfoItems.find('.garden-plan__map-info-item').last().find('.js-info-item-remove-btn');
        item.delegate(this, 'click', function () {
            removeTextOnClick($(this));
        });
    }
    function removeTextOnClick(removeBtn) {
        var infoItem = removeBtn.closest('.garden-plan__map-info-item');
        var row = infoItem.data('row');
        var column = infoItem.data('column');
        var area = plotArea.filter("[data-row=\"" + row + "\"]").filter("[data-column=\"" + column + "\"]");
        area.attr('data-text', '');
        area.find('.info-item-identifier').remove();
        infoItem.remove();
        var text = textItems.find(function (obj) { return obj.row === row.toString() && obj.column === column.toString(); });
        textItems.splice($.inArray(text, textItems), 1);
        updateTextItems();
        plotChanges = true;
        if (plot.find('.info-item-identifier').length < 1) {
            mapInfoWrapper.addClass('hidden');
        }
    }
    function updateTextItems() {
        $.each(textItems, function (index, item) {
            var textId = item.valueOf();
            plot.find("[data-row=\"" + textId.row + "\"]").filter("[data-column=\"" + textId.column + "\"]").find('.info-item-identifier span').text(index + 1);
            mapInfoItems.find("[data-row=\"" + textId.row + "\"]").filter("[data-column=\"" + textId.column + "\"]").find('.info-item-identifier').text(index + 1 + '.');
        });
    }
    function addTextHoverFunction() {
        $('.garden-planning__plot-area > .info-item-identifier').hover(function () {
            $(this).addClass('hover');
            var area = $(this).closest('.garden-planning__plot-area ');
            var areaRow = area.data('row');
            var areaCol = area.data('column');
            mapInfoItems.find("[data-row=\"" + areaRow + "\"]").filter("[data-column=\"" + areaCol + "\"]").addClass('hover');
        }, function () {
            removeTextHover($(this).closest('.garden-planning__plot-area '));
        });
        $('.garden-plan__map-info-item').hover(function () {
            var areaRow = $(this).data('row');
            var areaCol = $(this).data('column');
            plot.find("[data-row=\"" + areaRow + "\"]").filter("[data-column=\"" + areaCol + "\"]").find('.info-item-identifier').addClass('hover');
            mapInfoItems.find("[data-row=\"" + areaRow + "\"]").filter("[data-column=\"" + areaCol + "\"]").addClass('hover');
        }, function () {
            removeTextHover($(this));
        });
    }
    function removeTextHover(item) {
        var areaRow = item.data('row');
        var areaCol = item.data('column');
        plot.find("[data-row=\"" + areaRow + "\"]").filter("[data-column=\"" + areaCol + "\"]").find('.info-item-identifier').removeClass('hover');
        mapInfoItems.find("[data-row=\"" + areaRow + "\"]").filter("[data-column=\"" + areaCol + "\"]").removeClass('hover');
    }
    $('.js-garden-planning-empty-btn').on('click', function () {
        plotArea.each(function () {
            var area = $(this);
            changeAreaColor(area, toolEmpty);
            area.find('.info-item-identifier').remove();
            area.attr('data-text', '');
        });
        mapInfoItems.children().remove();
        mapInfoWrapper.addClass('hidden');
        textItems = [];
        plotChanges = true;
    });
    $('.js-garden-check-changes-btn').on('click', function (e) {
        if (plotChanges) {
            e.preventDefault();
            $('#garden-cancel-popup').closest('.popup-overlay').addClass('visible');
        }
        else {
            return;
        }
    });
    $('.js-garden-planning-save-btn').on('click', function () {
        var computedPlotAreas = getComputedPlotAreas();
        $('.garden-planning__button-wrapper').children().addClass('button--blured');
        $.ajax({
            url: '/min-tradgard/planera',
            method: 'POST',
            data: {
                plotAreas: computedPlotAreas,
                '__RequestVerificationToken': $('.js-anti-forgery' + ' input').val()
            }
        }).done(function (response) {
            var url = location.href;
            var str = url.substr(url.lastIndexOf('/') + 1);
            location.href = url.replace(new RegExp(str), '');
        }).fail(function (response) {
            // TODO: What to do when fail?
        });
    });
    function getComputedPlotAreas() {
        var min = 0;
        var rowMax = 16;
        var columnMax = 16;
        var computedPlotAreas = [];
        plotArea.each(function () {
            var area = $(this);
            var row = area.data('row');
            var column = area.data('column');
            var areaTypeId = area.data('area-type');
            var text = area.data('text');
            var computedPlotArea = {
                row: row,
                column: column,
                text: text,
                areaTypeId: areaTypeId,
                adjacentRight: false,
                adjacentBottom: false,
                adjacentLeftTopCorner: false
            };
            if (column < columnMax) {
                var adjacentRight = plotArea.filter("[data-row=\"" + row + "\"]").filter("[data-column=\"" + (column + 1) + "\"]");
                if (adjacentRight.data('area-type') !== areaTypeId) {
                    computedPlotArea.adjacentRight = true;
                }
                else {
                    area.removeClass('area-border-right');
                }
            }
            if (row < rowMax) {
                var adjacentBottom = plotArea.filter("[data-row=\"" + (row + 1) + "\"]").filter("[data-column=\"" + column + "\"]");
                if (adjacentBottom.data('area-type') !== areaTypeId) {
                    computedPlotArea.adjacentBottom = true;
                }
                else {
                    area.removeClass('area-border-bottom');
                }
            }
            if (row > min && column > min) {
                var adjacentTop = plotArea.filter("[data-row=\"" + (row - 1) + "\"]").filter("[data-column=\"" + column + "\"]");
                var adjacentLeft = plotArea.filter("[data-row=\"" + row + "\"]").filter("[data-column=\"" + (column - 1) + "\"]");
                if (adjacentTop.hasClass('area-border-bottom') && adjacentLeft.hasClass('area-border-right')) {
                    computedPlotArea.adjacentLeftTopCorner = true;
                    area.addClass('area-border-helper');
                }
            }
            computedPlotAreas.push(computedPlotArea);
            area.removeClass('garden-planning__plot-area-edit js-plot-area');
        });
        return computedPlotAreas;
    }
});
